module.exports = __webpack_public_path__ + "img/contrato-rastreabilidade.049e78d7.svg";